import React from 'react';
import PropTypes from 'prop-types';

import Text from 'components/Text';

export default function TextArea(props) {
  if (props.isSummary) {
    return <Text>{props.value || 'N/A'}</Text>;
  }
  
  const { dbc, disabled, ...restProps } = props;
  const className = `textarea-field ${disabled && dbc ? 'dbc' : ''}`;
  
  return <textarea className={className} disabled={disabled} {...restProps} />;
}

TextArea.propTypes = {
  isSummary: PropTypes.bool,
  value: PropTypes.any,
};




// WEBPACK FOOTER //
// ./app/containers/FastCover/components/TextArea/index.js